(function ($, window) {
  $('.mcl-pill').on('click touch', function (e) {
    $(this).toggleClass('active');
  });
})
(jQuery, window);
